import { clearAuthSession } from '@/features/auth/session';
import { clearZustandStore } from '@/legacy/store/zustand';
import { clearAllTableSessionParams } from '@/legacy/features/table/utils';
import { queryClient } from '@/legacy/lib';
import { LAST_CLEANUP_DATE_KEY } from '@/shared/hooks/useFilterReset';

const APP_VERSION_KEY = 'app_version';

// Canonical full app reset — normal logout and versionGuard mismatches must
// produce the same observable result (spec: "Auth-scoped clear vs full app
// reset"). Includes clearAllTableSessionParams() to match today's real
// logout-button behavior (clearAllStoresAndLocalStorage), not the narrower
// legacy logout() reducer which never called it.
export function resetAppState(): void {
	clearAuthSession();
	clearZustandStore();

	const appVersion = localStorage.getItem(APP_VERSION_KEY);
	localStorage.clear();
	if (appVersion) localStorage.setItem(APP_VERSION_KEY, appVersion);

	// Stamp today's cleanup date so useFIlterReset doesn't mistake this
	// unrelated clear for a real day boundary and wipe page filters again
	// right after ensurePage() sets them on the next mount.
	localStorage.setItem(LAST_CLEANUP_DATE_KEY, new Date().toDateString());

	clearAllTableSessionParams();
	queryClient.clear();
}
